import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { COMPARISON_SET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation PerformanceCenterSaveBenchmarkModel(
    $customerId: ID!
    $accountId: ID!
    $dataSource: PerformanceCenterDataSource!
    $name: String!
    $description: String!
    $userGoals: [String!]!
    $examples: [[String!]!]!
    $assetType: String!
    $deletedExamples: [[String!]!]!
    $examplesWithMetrics: [[ComparisonSetExampleInput!]!]!
  ) {
    performanceCenterSaveBenchmarkModel(
      customerId: $customerId
      accountId: $accountId
      dataSource: $dataSource
      name: $name
      description: $description
      userGoals: $userGoals
      examples: $examples
      assetType: $assetType
      deletedExamples: $deletedExamples
      examplesWithMetrics: $examplesWithMetrics
    ) {
      ...ComparisonSet
    }
  }
  ${COMPARISON_SET_FRAGMENT}
`;

export const performanceCenterSaveBenchmarkModel = ({
  customerId,
  accountId,
  dataSource,
  name,
  description,
  userGoals,
  examples,
  assetType,
  deletedExamples,
  examplesWithMetrics,
}) => {
  const variables = {
    customerId,
    accountId,
    dataSource,
    name,
    description,
    userGoals,
    examples,
    assetType,
    deletedExamples,
    examplesWithMetrics,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
